export const DOCUMENT_HINTS_ASYNC_THRESHOLD = 500;
